import Immutable from 'immutable';

import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_COMPANY_RESOURCE,
  CLEAR_COMPANY_RESOURCE_TYPES,
  CLEAR_COMPANY_RESOURCES,
  FLAG_COMPANY_RESOURCE_ACTIVITY,
  FLAG_GETTING_COMPANY_RESOURCE_TYPES,
  FLAG_GETTING_COMPANY_RESOURCES,
  GET_COMPANY_RESOURCE,
  GET_COMPANY_RESOURCE_TYPES,
  GET_COMPANY_RESOURCES,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  types: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_COMPANY_RESOURCES:
      return state.setIn(['all', 'loading'], payload);
    case GET_COMPANY_RESOURCES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_COMPANY_RESOURCES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_COMPANY_RESOURCE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_COMPANY_RESOURCE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_COMPANY_RESOURCE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_GETTING_COMPANY_RESOURCE_TYPES:
      return state.setIn(['types', 'loading'], payload);
    case GET_COMPANY_RESOURCE_TYPES:
      return state.setIn(['types', 'content'], Immutable.Map(payload));
    case CLEAR_COMPANY_RESOURCE_TYPES:
      return state.setIn(
        ['types', 'content'],
        INITIAL_STATE.getIn(['types', 'content']),
      );
    default:
      return state;
  }
};
